export const clinicProfile = {
  name: "Thaila Dental & Oral Care",
  tagline: "Oral Health, Overall Wellness",
  addressLines: [
    "T.S.No.5656, A.S.A. Complex, Opp. Old Govt Hospital, Apollo Medical Upstairs,",
    "Pudukkottai - 1, Tamil Nadu",
  ],
  phones: ["93608 38267", "63810 80356"],
};

